import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Exit = ({
  size,
  type,
  theme,
  className,
  dataTestId = "exit-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M0.974091 2.99194C0.974091 1.88737 1.86952 0.991943 2.97409 0.991943H8.83156C9.56794 0.991943 10.1649 1.5889 10.1649 2.32528V2.99194C10.1649 3.36013 9.86642 3.65861 9.49823 3.65861C9.13004 3.65861 8.83156 3.36013 8.83156 2.99194V2.32528H2.97409C2.6059 2.32528 2.30742 2.62375 2.30742 2.99194V13.0111C2.30742 13.3793 2.6059 13.6778 2.97409 13.6778H8.83156V13.0111C8.83156 12.6429 9.13004 12.3444 9.49823 12.3444C9.86642 12.3444 10.1649 12.6429 10.1649 13.0111V13.6778C10.1649 14.4141 9.56794 15.0111 8.83156 15.0111H2.97409C1.86952 15.0111 0.974091 14.1157 0.974091 13.0111V2.99194Z" />
    <path d="M5.50013 8.00236C5.50013 7.63417 5.79861 7.33569 6.1668 7.33569H12.8629L11.555 5.88023C11.3089 5.60636 11.3315 5.18486 11.6053 4.93877C11.8792 4.69268 12.3007 4.7152 12.5468 4.98907L14.8544 7.55715C15.0821 7.81056 15.0821 8.1949 14.8544 8.44831L12.5468 11.0164C12.3007 11.2903 11.8792 11.3128 11.6053 11.0667C11.3315 10.8206 11.3089 10.3991 11.555 10.1252L12.8635 8.66903H6.1668C5.79861 8.66903 5.50013 8.37055 5.50013 8.00236Z" />
  </SVGIcon>
);
